import { render, staticRenderFns } from "./PromotionCouponQuery.vue?vue&type=template&id=74122beb&"
import script from "./PromotionCouponQuery.vue?vue&type=script&lang=js&"
export * from "./PromotionCouponQuery.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCouponQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionCouponQuery.vue"
export default component.exports